import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import FrameMacSide from 'components/FrameMacSide'
import SectionWrapper from 'components/SectionWrapper'
import { REGION_JP } from 'constants/regions'
import { ResizeContext } from 'contexts/Resize'
import { LocalizationContext } from 'contexts/Localization'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import { Cover, Content, FrameWrapper, IconWrapper } from './styles'

const IMAGES =
  process.env.region === REGION_JP
    ? ['nutr_synthes_150921', 'nutr_fibers_150921', 'nutr_butyrate_150921']
    : ['nutr_synthes', 'nutr_fibers', 'nutr_butyrate']

const BResultsNutrition = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)
  const { paths: { shared } } = useContext(LocalizationContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className='row'>
        <div className='col-12 col-md-8'>
          <Cover />

          <FrameWrapper className='py-md-4'>
            <div className='position-relative py-4 py-md-0'>
              <H1 as='h2' dangerouslySetInnerHTML={{ __html: data.title }} />

              <FrameMacSide
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                <IconWrapper className='bread' src={`${shared}/icons/bread.png`} alt={`bread_img`} />

                <IconWrapper className='potion' src={`${shared}/icons/potion.png`} alt={`potion_img`} />
              </FrameMacSide>
            </div>
          </FrameWrapper>
        </div>

        <div className='col-12 py-4 col-md-4'>
          <Content>
            <ul className='list--unstyled w-100'>
              {data.list.map((item, key) => (
                <ClickableDescr
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  bulletColor={colors.lilacDark}
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

BResultsNutrition.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default BResultsNutrition
